import { Layers } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { InspecZ1Page } from './pages/InspecZ1Page'

/**
 * InSpec Z1 tracker (2026-10-14). InSpec Solutions orders Eclipse Z1
 * (CHMZO20) one dedicated 3,200 kg lot per PO, some shipped in two parts.
 * Upload their PO PDFs, see each shipment by ETA, assign/check the lot,
 * log the pre-ship call, return their spreadsheet with lots filled in.
 * Backend: /api/inspec-z1 (page key `inspec_z1`; sales read-only).
 */
export default defineModule({
  id: 'inspec-z1',
  name: 'InSpec Z1',
  shortName: 'InSpec Z1',
  icon: Layers,
  navSection: 'sales',
  navOrder: 80,
  urlNamespace: '/inspec-z1',
  routes: [{ path: '/', element: InspecZ1Page, label: 'InSpec Z1' }],
  permissions: ['admin', 'sales', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g s z',

  commandPaletteEntries: [
    {
      label: 'Go to InSpec Z1',
      keywords: ['inspec', 'zinc', 'z1', 'eclipse', 'chmzo20', 'lot', 'dedicated lot'],
      path: '/',
      group: 'modules',
      shortcut: 'g s z',
    },
  ],
})
